import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M16.47 10.53a.75.75 0 0 0 1.06 0l3-3a.75.75 0 0 0 0-1.06l-3-3a.75.75 0 0 0-1.06 1.06l1.72 1.72H4a.75.75 0 0 0 0 1.5h14.19l-1.72 1.72a.75.75 0 0 0 0 1.06M6.47 20.53a.75.75 0 1 0 1.06-1.06l-1.72-1.72H11a.75.75 0 0 0 0-1.5H5.81l1.72-1.72a.75.75 0 0 0-1.06-1.06l-3 3a.75.75 0 0 0 0 1.06zM16 17.75a.75.75 0 0 0 0-1.5h-2a.75.75 0 0 0 0 1.5zM20 17.75a.75.75 0 0 0 0-1.5h-1a.75.75 0 0 0 0 1.5z" />
  </>
);

const DoubleBack = Icon('double-back', svgContents);

export default DoubleBack;
